import { environment } from "@env/environment";
var themeA = require("@shared/styles/themes/theme-a.scss");
var themeB = require("@shared/styles/themes/theme-b.scss");
var themeC = require("@shared/styles/themes/theme-c.scss");
var themeD = require("@shared/styles/themes/theme-d.scss");
var themeE = require("@shared/styles/themes/theme-e.scss");
var themeF = require("@shared/styles/themes/theme-f.scss");
var themeG = require("@shared/styles/themes/theme-g.scss");
var themeH = require("@shared/styles/themes/theme-h.scss");
var ThemesService = /** @class */ (function () {
    function ThemesService() {
        this.defaultTheme = environment.defaultTheme;
        this.createStyle();
        if (localStorage.getItem("Theme") != null)
            this.defaultTheme = localStorage.getItem("Theme");
        this.setTheme(this.defaultTheme);
    }
    ThemesService.prototype.createStyle = function () {
        var head = document.head || document.getElementsByTagName("head")[0];
        this.styleTag = document.createElement("style");
        this.styleTag.type = "text/css";
        this.styleTag.id = "appthemes";
        head.appendChild(this.styleTag);
    };
    ThemesService.prototype.setTheme = function (name) {
        localStorage.setItem("Theme", name);
        switch (name) {
            case "A":
                this.injectStylesheet(themeA);
                break;
            case "B":
                this.injectStylesheet(themeB);
                break;
            case "C":
                this.injectStylesheet(themeC);
                break;
            case "D":
                this.injectStylesheet(themeD);
                break;
            case "E":
                this.injectStylesheet(themeE);
                break;
            case "F":
                this.injectStylesheet(themeF);
                break;
            case "G":
                this.injectStylesheet(themeG);
                break;
            case "H":
                this.injectStylesheet(themeH);
                break;
        }
    };
    ThemesService.prototype.injectStylesheet = function (css) {
        this.styleTag.innerHTML = css;
    };
    ThemesService.prototype.getDefaultTheme = function () {
        return this.defaultTheme;
    };
    return ThemesService;
}());
export { ThemesService };
